import store from "@/stores/store.js";

export default {
    links: {
        fleet: {
            dev: "http://client.stanislas.poisson.corp.suivideflotte.net/login/?key={key}&fromDelegate=1",
            rc: "https://rc.suivideflotte.net/login/?key={key}&fromDelegate=1",
            pp: "https://pp-client.suivideflotte.net/login/?key={key}&fromDelegate=1",
            prod: "https://client.suivideflotte.net/login/?key={key}&fromDelegate=1"
        },

        park: {
            dev: "http://parc.stanislas.poisson.corp.suivideflotte.net/login/?key={key}&fromDelegate=1",
            rc: "https://rc-parc.suivideflotte.net/login/?key={key}&fromDelegate=1",
            pp: "https://pp-parc.suivideflotte.net/login/?key={key}&fromDelegate=1",
            prod: "https://parc.suivideflotte.net/login/?key={key}&fromDelegate=1"
        },

        mission: {
            dev: "http://mission.stanislas.poisson.corp.suivideflotte.net",
            rc: "https://rc-mission.suivideflotte.net",
            pp: "https://pp-mission.suivideflotte.net",
            prod: "https://mission.suivideflotte.net"
        },

        bom: {
            dev: "http://client.stanislas.poisson.corp.suivideflotte.net/redirect/bom",
            rc: "https://v4.suivideflotte.net/editeurtournee",
            pp: "https://v4.suivideflotte.net/editeurtournee",
            prod: "https://v4.suivideflotte.net/editeurtournee"
        },

        vision: {
            dev: "http://client.stanislas.poisson.corp.suivideflotte.net/redirect/suivivision",
            rc: "https://v4.suivideflotte.net/suivivision/",
            pp: "https://v4.suivideflotte.net/suivivision/",
            prod: "https://v4.suivideflotte.net/suivivision/"
        },

        manager: {
            dev: "https://manager.develop.corp.suivideflotte.net/#/users?token={token}&from={from}",
            rc: "https://manager.releases.corp.suivideflotte.net/#/users?token={token}&from={from}",
            pp: "https://manager.releases.corp.suivideflotte.net/#/users?token={token}&from={from}",
            prod: "https://manager.suivideflotte.net/#/users?token={token}&from={from}"
        },
        beepizManager: {
            dev: "https://manager.develop.corp.beepiz.com/#/users?token={token}&from={from}",
            rc: "https://manager.releases.corp.beepiz.com/#/users?token={token}&from={from}",
            pp: "https://pp-manager.beepiz.com/#/users?token={token}&from={from}",
            prod: "https://manager.beepiz.com/#/users?token={token}&from={from}"
        },
        sfrManager: {
            dev: "https://manager-sfr.develop.corp.beepiz.com/#/users?token={token}&from={from}",
            rc: "https://manager-sfr.releases.corp.beepiz.com/#/users?token={token}&from={from}",
            pp: "https://pp-manager-sfr.beepiz.com/#/users?token={token}&from={from}",
            prod: "https://manager-sfr.beepiz.com/#/users?token={token}&from={from}"
        },
        catsafeManager: {
            dev: "https://manager-catsafe.develop.corp.beepiz.com/#/users?token={token}&from={from}",
            rc: "https://manager-catsafe.releases.corp.beepiz.com/#/users?token={token}&from={from}",
            pp: "https://pp-manager-catsafe.beepiz.com/#/users?token={token}&from={from}",
            prod: "https://manager-catsafe.beepiz.com/#/users?token={token}&from={from}"
        },

        beepiz: {
            dev: "https://client.develop.corp.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            rc: "https://client.releases.corp.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            pp: "https://pp-client.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            prod: "https://client.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}"
        },
        sfrBeepiz: {
            dev: "https://sfr.develop.corp.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            rc: "https://sfr.releases.corp.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            pp: "https://pp-sfr.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            prod: "https://sfr.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}"
        },
        catsafeBeepiz: {
            dev: "https://catsafe-client.develop.corp.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            rc: "https://catsafe-client.releases.corp.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            pp: "https://pp-catsafe-client.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}",
            prod: "https://catsafe-client.beepiz.com/#/home?v2_token={token}&v2_lang={lang}{refresh}"
        },

        support: {
            dev: "http://support.develop.corp.suivideflotte.net/login/?key={key}&fromDelegate=1",
            rc: "https://support.releases.corp.suivideflotte.net/login/?key={key}&fromDelegate=1",
            pp: "https://pp-support.suivideflotte.net/login/?key={key}&fromDelegate=1",
            prod: "https://support.suivideflotte.net/login/?key={key}&fromDelegate=1"
        },
        beepizSupport: {
            dev: "https://manager.develop.corp.beepiz.com/login/?key={key}&fromDelegate=1",
            rc: "https://manager.releases.corp.beepiz.com/login/?key={key}&fromDelegate=1",
            pp: "https://pp-manager.beepiz.com/login/?key={key}&fromDelegate=1",
            prod: "https://assistance.beepiz.com/login/?key={key}&fromDelegate=1"
        },
        sfrSupport: {
            dev: "https://assistance-sfr.develop.corp.beepiz.com/login/?key={key}&fromDelegate=1",
            rc: "https://assistance-sfr.releases.corp.beepiz.com/login/?key={key}&fromDelegate=1",
            pp: "https://pp-assistance-sfr.beepiz.com/login/?key={key}&fromDelegate=1",
            prod: "https://assistance-sfr.beepiz.com/login/?key={key}&fromDelegate=1"
        },
        catsafeSupport: {
            dev: "https://assistance-catsafe.develop.corp.beepiz.com/login/?key={key}&fromDelegate=1",
            rc: "https://assistance-catsafe.releases.corp.beepiz.com/login/?key={key}&fromDelegate=1",
            pp: "https://pp-assistance-catsafe.beepiz.com/login/?key={key}&fromDelegate=1",
            prod: "https://assistance-catsafe.beepiz.com/login/?key={key}&fromDelegate=1"
        },
    },

    getLink(universe) {
        const locationHostName = window.location.hostname;
        let env = "prod";

        if (
            locationHostName.includes("localhost") ||
            -1 != locationHostName.indexOf("develop")
        ) {
            env = "dev";
        } else if (-1 != locationHostName.indexOf("releases")) {
            env = "rc";
        } else if (-1 != locationHostName.indexOf("master") || -1 != locationHostName.indexOf("pp-")) {
            env = "pp";
        }

        const refreshToken = window.V.$localStorage.get("REFRESH_TOKEN");
        return this.links[universe][env]
            .replace("{token}", store.getters["Auth/accessToken"])
            .replace("{key}", store.getters["Auth/key"])
            .replace("{from}", window.location.href)
            .replace("{lang}", window.V.$localStorage.get("MANAGER_LOCALE"))
            .replace("{refresh}", !!refreshToken ? `&v2_refresh=${refreshToken}` : '');
    },
};



// WEBPACK FOOTER //
// ./src/services/hub.js